import React from 'react';

const styles = {
  group: { marginBottom: '16px' },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: 500,
    color: 'var(--text)',
    marginBottom: '6px',
    letterSpacing: '0.01em',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    fontSize: '14px',
    fontFamily: "'Space Grotesk', sans-serif",
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    background: 'var(--surface)',
    color: 'var(--text)',
    outline: 'none',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  },
};

export default function FormField({ label, ...props }) {
  const [focused, setFocused] = React.useState(false);
  return (
    <div style={styles.group}>
      {label && <label style={styles.label}>{label}</label>}
      <input
        {...props}
        style={{
          ...styles.input,
          borderColor: focused ? 'var(--accent)' : 'var(--border)',
          boxShadow: focused ? '0 0 0 3px var(--accent-dim)' : 'none',
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </div>
  );
}
